import { Pencil } from "lucide-react";

type Props = {
  onClick: () => void;
};

export function MobileComposeFab({ onClick }: Props) {
  return (
    <div className="mobile-compose-fab-wrap">
      <button
        type="button"
        className="mobile-compose-fab"
        aria-label="Nouveau message"
        onClick={onClick}
      >
        <Pencil className="h-6 w-6" strokeWidth={2} aria-hidden />
      </button>
    </div>
  );
}
